/* ============================================================
   FLG GALLERY v5, 2026-09-24. The parcel gallery engine.

   Loaded by sections/flg-parcel-gallery.liquid. It is a separate
   asset and not inline script so the browser caches it once
   across every parcel page.

   ------------------------------------------------------------
   v5. THE BLACK AREA IS A CONTROL, NOT PART OF THE PHOTOGRAPH.
   ------------------------------------------------------------
   Harpreet, 2026-09-24, on desktop: unless he hit the right
   arrow exactly, clicking anywhere in the black took it as a
   zoom. Instead of changing the picture it magnified.

   THE CAUSE. tap-to-zoom was guarded by isImage(), which asks
   "is the loaded media an image", NOT "did the pointer land on
   the image". .flgg__view fills the whole screen, so a click on
   the black surround passed that guard exactly like a click on
   the photograph and zoomed.

   A 7:5 photo in a 1440 x 700 window is 980 x 700, which leaves
   230px of black down each side. That is a huge target, it is
   the first thing a mouse lands on, and it did the one thing
   the buyer did not ask for.

   THE FIX. pointerdown now records WHERE the press landed, and
   a click resolves by position:

     on the photograph   toggle 1x and 2.5x, centred on the click
     black on the left   previous photo
     black on the right  next photo
     X or Esc            close

   A drag can also only begin on the photograph now. Dragging
   from the black surround used to slide the picture sideways,
   which is a gesture nobody asked for on a mouse.

   NOTE, AND SAY SO IF IT COMES UP: clicking the black no longer
   closes the viewer, because it now navigates. Close is the X
   and Esc. If closing on the backdrop is ever wanted back, the
   two behaviours cannot share the same click, so one of them
   has to move to a double click or a different target.

   THE RULE THIS LEAVES BEHIND: never guard a pointer behaviour
   on what is loaded. Guard it on where the pointer is. isImage()
   answers a question about state. pointOnImage() answers the
   question about the event. They are not interchangeable and
   mixing them up is what produced this.

   ------------------------------------------------------------
   THE VIEWER IS TWO DIFFERENT THINGS, ON PURPOSE.
   ------------------------------------------------------------
   PHONE, under 900px:  a vertical column. Every photo at the
                        full width of the device, stacked, scroll
                        down through all of them.
   DESKTOP, 900 and up: a single framed image, with arrows,
                        keyboard, click to zoom and click to
                        navigate.

   WHY. A landscape photograph cannot fill a portrait phone. FLG
   exports are 2100 x 1500, which is 7:5. On a 390 x 844 screen,
   fitted to the width, that is 390 x 279 and uses 33% of the
   display. To make it reach 844 tall you must scale it 3.03x,
   at which point it is 1182 wide and the buyer sees 390 of
   1182, THIRTY THREE PERCENT OF THE PHOTOGRAPH. On a drone shot
   that puts the boundary lines off screen.

   So a pager wastes two thirds of the screen and a filled pager
   hides two thirds of the picture. A column has neither
   problem. DO NOT "UNIFY" THESE TWO MODES. A pager is right
   where the screen is wider than the photo. A column is right
   where it is taller.

   ------------------------------------------------------------
   THE COLUMN NEEDS THE DIMENSIONS, AND THAT IS NOT OPTIONAL
   ------------------------------------------------------------
   Tapping photo 7 must land on photo 7, so the column has to
   know how tall the first six are BEFORE they download. Every
   item in the JSON payload carries w and h, each image gets
   them as width and height attributes, the browser reserves the
   box from the ratio, and offsetTop is right on the first
   frame. Strip w and h out and the column silently lands on the
   wrong photograph. It will not throw.

   The column also asks for a 900 / 1400 / 2400 srcset at sizes
   100vw rather than the single 2400px file the framed pager
   uses, because ten 2400px photos over cellular is a wait.

   ------------------------------------------------------------
   THE BUG THAT colTick CAUSED. DO NOT REINTRODUCE.
   ------------------------------------------------------------
   renderColumn used to end with a call to colTick, which felt
   tidy. colTick derives i FROM THE SCROLL POSITION, and at that
   moment scrollTop is 0, so i was overwritten with 1 before
   scrollToIndex(i) ran. Tapping the seventh photograph opened
   the second. No error, nothing in the console.

   THE RULE: i is an OUTPUT of scrolling, never an input to it.
   Anything that scrolls the column passes the index it wants as
   an argument. Nothing reads i to decide where to go.

   ------------------------------------------------------------
   THE COLUMN COUNTER READS THE TOP EDGE, NOT THE CENTRE
   ------------------------------------------------------------
   A 7:5 photo on a 390 x 844 phone is 279 tall, so THREE are on
   screen at once. Answering "which photo am I on" with whichever
   is nearest the middle made tapping photo 7 open photo 7 and
   then announce 8 / 10. It now names the photo at the TOP, which
   is the one scrollToIndex puts there. The bottom is special
   cased, because once the column is scrolled as far as it goes
   the last photo's top can never reach the top of the screen and
   the counter would stop one short.

   ------------------------------------------------------------
   THE PAGE STRIP COUNTER
   ------------------------------------------------------------
   Position is scrollLeft divided by the width of one slide,
   which works because every slide is exactly 100% of the strip
   with NO GAP. If a gap or a peek is ever put back, the chip
   drifts by one somewhere down the strip.

   NO requestAnimationFrame anywhere in this file. The first cut
   throttled the scroll handler through rAF, which is the
   reflex, and it was wrong twice over: rAF does not fire in a
   hidden tab, so the counter was untestable and would silently
   stop in a backgrounded one, and the throttle bought nothing
   because the width is measured once and on resize rather than
   inside the handler. Do not put it back.
   ============================================================ */
(function () {
  'use strict';

  var MAX = 4;
  var DOUBLE = 2.5;
  var SLOP = 12;       /* px of drift allowed before a mode is set   */
  var DISMISS = 110;   /* px of downward drag that closes the column */

  var warm = {};       /* preloaded sources, shared page wide */

  function init(root) {
    if (!root || root.__flgg) return;
    root.__flgg = true;

    var lb = root.querySelector('[data-flgg-lb]');
    var view = root.querySelector('[data-flgg-view]');
    var num = root.querySelector('[data-flgg-num]');
    var dots = root.querySelector('[data-flgg-dots]');
    var data = root.querySelector('[data-flgg-items]');
    if (!lb || !view || !data) return;

    var items = [];
    try { items = JSON.parse(data.textContent) || []; } catch (e) { return; }
    if (!items.length) return;

    var mq = window.matchMedia('(max-width:899px)');
    function isPhone() { return mq.matches; }

    /* i is an OUTPUT of scrolling in column mode. See the header.
       Never read it to decide where to scroll. */
    var i = 0;
    var opener = null;
    var el = null;          /* the live media element, PAGER ONLY */
    var slides = [];        /* the column's wrappers, PHONE ONLY  */
    var colMode = false;
    var scale = 1, tx = 0, ty = 0;

    /* ---------- shared media building ---------- */

    function mediaNode(it, forColumn) {
      var node;
      if (it.t === 'video') {
        node = document.createElement('video');
        node.src = it.src;
        if (it.poster) node.poster = it.poster;
        node.controls = true;
        node.playsInline = true;
        node.preload = forColumn ? 'none' : 'metadata';
      } else if (it.t === 'embed') {
        node = document.createElement('iframe');
        node.src = it.src;
        node.allow = 'accelerometer; encrypted-media; gyroscope; picture-in-picture';
        node.setAttribute('allowfullscreen', '');
      } else {
        node = document.createElement('img');
        node.alt = it.alt || '';
        node.draggable = false;
        node.decoding = 'async';
        if (forColumn && it.src1 && it.src2) {
          node.srcset = it.src1 + ' 900w, ' + it.src2 + ' 1400w, ' + it.src + ' 2400w';
          node.sizes = '100vw';
        }
        node.src = it.src;
      }
      if (it.w && it.h) { node.width = it.w; node.height = it.h; }
      return node;
    }

    /* ---------- the phone column ---------- */

    function renderColumn() {
      view.innerHTML = '';
      view.style.transform = '';
      view.scrollTop = 0;
      slides = [];
      el = null;                 /* keeps the pager gestures asleep */
      scale = 1; tx = 0; ty = 0;

      for (var k = 0; k < items.length; k++) {
        var wrap = document.createElement('div');
        wrap.className = 'flgg__slide';
        var node = mediaNode(items[k], true);
        if (node.tagName === 'IMG') node.loading = 'lazy';
        wrap.appendChild(node);
        view.appendChild(wrap);
        slides.push(wrap);
      }
      /* DELIBERATELY NO colTick HERE. See the header. */
    }

    function scrollToIndex(n) {
      if (!slides[n]) return;
      [n - 1, n, n + 1].forEach(function (k) {
        var s = slides[k];
        if (!s) return;
        var im = s.firstElementChild;
        if (im && im.tagName === 'IMG') im.loading = 'eager';
      });
      view.scrollTop = slides[n].offsetTop;
      colTick();
    }

    function colTick() {
      if (!slides.length) return;
      var top = view.scrollTop;
      var k = 0;
      for (var q = 0; q < slides.length; q++) {
        if (slides[q].offsetTop <= top + 8) k = q;
      }
      if (top + view.clientHeight >= view.scrollHeight - 2) k = slides.length - 1;
      i = k;
      if (num) num.textContent = (i + 1) + ' / ' + items.length;
    }

    /* ---------- the desktop pager ---------- */

    function clamp() {
      if (scale <= 1) { tx = 0; ty = 0; return; }
      var r = view.getBoundingClientRect();
      var lim = function (n, span) {
        var max = (span * (scale - 1)) / 2;
        return Math.max(-max, Math.min(max, n));
      };
      tx = lim(tx, r.width);
      ty = lim(ty, r.height);
    }

    function paint() {
      if (!el || el.tagName !== 'IMG') return;
      clamp();
      el.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
      el.style.cursor = scale > 1 ? 'grab' : 'zoom-in';
    }

    function resetZoom() { scale = 1; tx = 0; ty = 0; paint(); }

    function warmOne(k) {
      var it = items[(k + items.length) % items.length];
      if (!it || it.t !== 'image' || !it.src || warm[it.src]) return;
      warm[it.src] = true;
      var im = new Image();
      im.decoding = 'async';
      im.src = it.src;
    }

    function warmNeighbours() {
      if (items.length < 2) return;
      warmOne(i + 1);
      warmOne(i - 1);
    }

    function render() {
      var it = items[i];
      view.innerHTML = '';
      view.style.transform = '';
      slides = [];
      scale = 1; tx = 0; ty = 0;

      el = mediaNode(it, false);
      if (el.tagName === 'IMG') {
        el.addEventListener('load', warmNeighbours, { once: true });
        el.addEventListener('error', warmNeighbours, { once: true });
        if (el.complete) warmNeighbours();
      } else {
        warmNeighbours();
      }
      view.appendChild(el);
      paint();

      if (num) num.textContent = (i + 1) + ' / ' + items.length;
      if (dots) {
        var kids = dots.children;
        for (var d = 0; d < kids.length; d++) {
          kids[d].setAttribute('aria-current', d === i ? 'true' : 'false');
        }
      }
    }

    function step(d) {
      if (colMode) return;
      i = (i + d + items.length) % items.length;
      render();
    }

    /* ---------- open and close ---------- */

    function open(n, from) {
      var want = n || 0;
      i = want;
      opener = from || null;
      colMode = isPhone();
      lb.classList.add('on');
      document.documentElement.style.overflow = 'hidden';
      if (colMode) { renderColumn(); scrollToIndex(want); }
      else { render(); }
      var x = root.querySelector('[data-flgg-close]');
      if (x) x.focus();
    }

    function close() {
      lb.classList.remove('on');
      lb.style.transition = '';
      lb.style.backgroundColor = '';
      view.style.transition = '';
      view.style.transform = '';
      view.innerHTML = '';
      slides = [];
      el = null;
      resetZoom();
      document.documentElement.style.overflow = '';
      if (opener) { try { opener.focus(); } catch (e) {} }
    }

    var onMQ = function () {
      if (!lb.classList.contains('on')) return;
      var want = isPhone();
      if (want === colMode) return;
      var keep = i;
      colMode = want;
      if (colMode) { renderColumn(); scrollToIndex(keep); }
      else { i = keep; render(); }
    };
    if (mq.addEventListener) mq.addEventListener('change', onMQ);
    else if (mq.addListener) mq.addListener(onMQ);

    view.addEventListener('scroll', function () {
      if (colMode) colTick();
    }, { passive: true });

    /* ---------- drag down at the top to dismiss, column only ---- */

    var dActive = false, dStartY = 0, dMoved = 0;

    view.addEventListener('pointerdown', function (e) {
      if (!colMode) return;
      if (view.scrollTop > 0) return;
      dActive = true; dStartY = e.clientY; dMoved = 0;
    });

    view.addEventListener('pointermove', function (e) {
      if (!colMode || !dActive) return;
      var dy = e.clientY - dStartY;
      if (dy <= SLOP) { if (dMoved === 0 && dy < -SLOP) dActive = false; return; }
      if (view.scrollTop > 0) { dActive = false; return; }
      dMoved = dy;
      var fade = Math.min(dy / 420, 0.55);
      view.style.transform = 'translateY(' + dy + 'px)';
      lb.style.backgroundColor = 'rgba(12,13,16,' + (1 - fade) + ')';
    });

    function colRelease() {
      if (!colMode || !dActive) return;
      dActive = false;
      if (dMoved > DISMISS) { dMoved = 0; close(); return; }
      if (dMoved > 0) {
        view.style.transition = 'transform .2s ease';
        lb.style.transition = 'background-color .2s ease';
        view.style.transform = '';
        lb.style.backgroundColor = '';
        setTimeout(function () {
          view.style.transition = '';
          lb.style.transition = '';
        }, 220);
      }
      dMoved = 0;
    }

    view.addEventListener('pointerup', colRelease);
    view.addEventListener('pointercancel', colRelease);

    /* ---------- pager gestures ---------- */

    var pts = {};
    var mode = '';
    var startX = 0, startY = 0, baseTx = 0, baseTy = 0;
    var baseScale = 1, baseDist = 0;
    var downOnImage = false;

    function dist(a, b) {
      var dx = a.x - b.x, dy = a.y - b.y;
      return Math.sqrt(dx * dx + dy * dy);
    }
    function two() {
      var k = Object.keys(pts);
      return k.length >= 2 ? [pts[k[0]], pts[k[1]]] : null;
    }

    /* STATE. Is the loaded media an image at all. */
    function isImage() { return !colMode && el && el.tagName === 'IMG'; }

    /* EVENT. Did this pointer land on the photograph itself.
       These two are NOT interchangeable. Read the v5 note. */
    function pointOnImage(x, y) {
      if (!el) return false;
      var r = el.getBoundingClientRect();
      return x >= r.left && x <= r.right && y >= r.top && y <= r.bottom;
    }

    view.addEventListener('pointerdown', function (e) {
      if (!isImage()) return;
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      try { view.setPointerCapture(e.pointerId); } catch (err) {}

      var pair = two();
      if (pair) {
        mode = 'pinch';
        baseDist = dist(pair[0], pair[1]);
        baseScale = scale;
        return;
      }

      startX = e.clientX; startY = e.clientY;
      baseTx = tx; baseTy = ty;
      downOnImage = pointOnImage(e.clientX, e.clientY);
      mode = (scale > 1 && downOnImage) ? 'pan' : '';
    });

    view.addEventListener('pointermove', function (e) {
      if (!isImage() || !pts[e.pointerId]) return;
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };

      if (mode === 'pinch') {
        var pair = two();
        if (!pair) return;
        var f = dist(pair[0], pair[1]) / (baseDist || 1);
        scale = Math.max(1, Math.min(MAX, baseScale * f));
        paint();
        e.preventDefault();
        return;
      }

      var dx = e.clientX - startX;
      var dy = e.clientY - startY;

      if (mode === 'pan') {
        tx = baseTx + dx; ty = baseTy + dy;
        paint();
        e.preventDefault();
        return;
      }

      /* A drag can only START on the photograph. Dragging from
         the black surround used to slide the picture sideways,
         which is a gesture nobody asked for on a mouse. */
      if (mode === '' && downOnImage && Math.abs(dx) > SLOP && Math.abs(dx) > Math.abs(dy)) {
        mode = 'swipe';
      }
      if (mode === 'swipe') {
        el.style.transform = 'translateX(' + dx + 'px)';
        e.preventDefault();
      }
    });

    function release(e) {
      if (!pts[e.pointerId]) return;
      var dx = e.clientX - startX;
      var dy = e.clientY - startY;
      delete pts[e.pointerId];

      var wasClick = (mode === '' || mode === 'pan') &&
                     Math.abs(dx) < SLOP && Math.abs(dy) < SLOP;

      if (wasClick && !downOnImage) {
        /* THE BLACK SURROUND IS A CONTROL. Left half goes back,
           right half goes on. This is the v5 fix: it used to
           zoom, because the guard asked what was loaded rather
           than where the pointer was. */
        var r = view.getBoundingClientRect();
        step(e.clientX < r.left + r.width / 2 ? -1 : 1);
      } else if (wasClick) {
        /* TAP TO ZOOM, centred on where the pointer landed.

           This was a DOUBLE tap until 2026-09-21 and it did not
           fire. The detector lived in pointerdown behind a 300ms
           window, and pointerdown returns early whenever a
           second pointer is still registered, so a stray pointer
           left the window permanently unreachable. A timing
           window that can be starved is not a gesture, it is a
           coin flip.

           'pan' IS ACCEPTED HERE AND MUST STAY ACCEPTED. The
           moment an image is zoomed, pointerdown sets mode to
           'pan' so a drag can move the picture. Testing for ''
           on its own made zooming OUT impossible: the tap that
           should have restored the photo was classed as a pan
           that happened not to travel. A pan of under SLOP
           pixels did not pan. It was a tap. */
        if (scale > 1) {
          resetZoom();
        } else {
          var vr = view.getBoundingClientRect();
          scale = DOUBLE;
          tx = (vr.width / 2 - (e.clientX - vr.left)) * (DOUBLE - 1);
          ty = (vr.height / 2 - (e.clientY - vr.top)) * (DOUBLE - 1);
          paint();
        }
      }

      if (mode === 'swipe') {
        el.style.transition = 'transform .18s ease';
        if (Math.abs(dx) > 45) { step(dx < 0 ? 1 : -1); }
        else { paint(); }
        setTimeout(function () { if (el) el.style.transition = ''; }, 200);
      }

      if (Object.keys(pts).length === 0) mode = '';
      else if (mode === 'pinch') { mode = ''; }
    }

    view.addEventListener('pointerup', release);
    view.addEventListener('pointercancel', release);

    view.addEventListener('click', function (e) {
      if (!isImage()) return;
      if (e.detail === 0) return;
      if (mode === 'swipe' || mode === 'pan') { mode = ''; return; }
    });

    /* ---------- wiring ---------- */

    root.querySelectorAll('[data-flgg-open]').forEach(function (b) {
      b.addEventListener('click', function () {
        open(parseInt(b.getAttribute('data-flgg-open'), 10) || 0, b);
      });
    });

    var x = root.querySelector('[data-flgg-close]');
    var p = root.querySelector('[data-flgg-prev]');
    var n = root.querySelector('[data-flgg-next]');
    if (x) x.addEventListener('click', close);
    if (p) p.addEventListener('click', function () { step(-1); });
    if (n) n.addEventListener('click', function () { step(1); });

    if (dots) {
      dots.addEventListener('click', function (e) {
        var b = e.target.closest('[data-flgg-go]');
        if (!b) return;
        var k = parseInt(b.getAttribute('data-flgg-go'), 10) || 0;
        if (colMode) { scrollToIndex(k); } else { i = k; render(); }
      });
    }

    /* ---------- the page strip counter ---------- */

    var strip = root.querySelector('[data-flgg-strip]');
    var chip = root.querySelector('[data-flgg-idx]');
    if (strip && chip) {
      var slide = 0;

      var tick = function () {
        var count = strip.children.length;
        if (!count || !slide) return;
        var k = Math.round(strip.scrollLeft / slide) + 1;
        if (k < 1) k = 1;
        if (k > count) k = count;
        var t = k + ' / ' + count;
        if (chip.textContent !== t) chip.textContent = t;
      };

      var remeasure = function () {
        slide = strip.children.length
          ? strip.children[0].getBoundingClientRect().width
          : 0;
        tick();
      };

      strip.addEventListener('scroll', tick, { passive: true });
      window.addEventListener('resize', remeasure, { passive: true });
      window.addEventListener('orientationchange', remeasure, { passive: true });

      remeasure();
      if (document.readyState !== 'complete') {
        window.addEventListener('load', remeasure);
      }
    }

    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('on')) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      else if (!colMode && e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
      else if (!colMode && e.key === 'ArrowRight') { e.preventDefault(); step(1); }
    });
  }

  function boot() {
    document.querySelectorAll('[data-flgg-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();